import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';

export const Button = React.forwardRef(
  (
    {
      label = 'Button',
      className = '',
      onClick = () => {},
      disabled = false,
      loading = false,
      icon = null,
      iconPosition = 'left', // 'left' | 'right'
      onBlur = () => {},
      style = {},
      dataTestid = null,
      type = 'button',
    },
    ref
  ) => {
    const isDisabled = disabled || loading;

    const renderContent = () => {
      if (loading) {
        return (
          <span className="flex items-center gap-2">
            <LoadingOutlined aria-hidden="true" />
            <span>{label}</span>
          </span>
        );
      }
      if (!icon) return label;
      return (
        <span className="flex items-center gap-2">
          {iconPosition === 'left' && icon}
          <span>{label}</span>
          {iconPosition === 'right' && icon}
        </span>
      );
    };

    return (
      <button
        ref={ref}
        type={type}
        disabled={isDisabled}
        onClick={isDisabled ? undefined : onClick}
        onBlur={onBlur}
        style={style}
        data-testid={dataTestid}
        aria-busy={loading || undefined}
        className={`border rounded-md py-2 px-3 text-base inline-flex items-center justify-center ${className} ${
          isDisabled ? 'opacity-60 cursor-not-allowed' : ''
        }`}
      >
        {renderContent()}
      </button>
    );
  }
);
